import { LOG_OUT } from "../login/action";
import {
  CLOSE_VISITOR_PERMIT_ORDER_SUCCESS_MODAL,
  OPEN_VISITOR_PERMIT_ORDER_SUCCESS_MODAL,
  SET_CARD_TYPE_VISITOR_PERMIT,
  SET_VISITOR_PERMIT,
  SET_VISITOR_PERMITLIST,
} from "./action";

export const defaultState = {
  visitorPermitListState: [],
  visitorPermit: [],
  visitorPermitCardType: [],
  isOpenOrderSuccessModal: false,
};

function visitorPermitReducer(state = defaultState, action) {
  switch (action.type) {
    case SET_VISITOR_PERMITLIST:
      return {
        ...state,
        visitorPermitListState: action.payload,
      };
    case SET_VISITOR_PERMIT:
      return {
        ...state,
        visitorPermit: action.payload,
      };
    case SET_CARD_TYPE_VISITOR_PERMIT:
      return {
        ...state,
        visitorPermitCardType: action.payload,
      };
    case OPEN_VISITOR_PERMIT_ORDER_SUCCESS_MODAL:
      return {
        ...state,
        isOpenOrderSuccessModal: action.payload,
      };
    case CLOSE_VISITOR_PERMIT_ORDER_SUCCESS_MODAL:
      return {
        ...state,
        isOpenOrderSuccessModal: action.payload,
      };
    case LOG_OUT:
      return defaultState;
    default:
      return state;
  }
}

export default visitorPermitReducer;
